import { render, staticRenderFns } from "./HtRoleSelector.vue?vue&type=template&id=353da624&scoped=true&"
import script from "./HtRoleSelector.vue?vue&type=script&lang=js&"
export * from "./HtRoleSelector.vue?vue&type=script&lang=js&"
import style0 from "./HtRoleSelector.vue?vue&type=style&index=0&id=353da624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353da624",
  null
  
)

export default component.exports